export default __webpack_public_path__ + "static/media/iconfont.fdd648ad.woff";